import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Button, Table, Form } from 'react-bootstrap';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import Flex from 'components/common/Flex';
import UnrequestHistory from 'components/pages/haccp/monitoring/common/modal/UnrequestHistory';
import { useConfirmModalState } from 'global/confirmModalState';
// function
import { getLoginInform } from 'function/login';
// types
import { RESPONSE_CODE } from 'types/const';
// api
import {
  unrequestDetail,
  unrequestCreate,
  unrequestComments
} from 'api/haccp/monitoring/productApi';

/**
 * @description 미의뢰 내역 상세페이지
 */

const Detail = () => {
  /* router info*/
  const history = useHistory();
  const { seq } = useParams();
  const { state } = useLocation();

  /* recoil */
  const { setConfirmModal } = useConfirmModalState();

  /* state */
  const [modalShow, setModalShow] = useState(false);
  // 로그인User Seq
  const [userSeq, setUserSeq] = useState(null);
  // 미의뢰정보
  const [unsolicitedInfo, setUnsolicitedInfo] = useState({});
  // 미의뢰사유
  const [reason, setReason] = useState('');
  // 미의뢰사유 이력
  const [historyList, setHistoryList] = useState([]);
  // 미의뢰사유 등록 개별 or 그룹
  const [groupYn, setGroupYn] = useState('');
  // 등록 or 수정
  const [action, setAction] = useState('등록');

  /* event */

  /* 미의뢰사유 목록페이지 이동 */
  const onList = () => {
    history.push({
      pathname: '/haccp/monitoring/production/unRequested',
      state: state
    });
  };

  /* 수정이력 모달 Open */
  const onHistoryModal = async () => {
    const response = await unrequestComments(seq);

    const { code, message, list } = response || {};

    if (code !== RESPONSE_CODE.Success) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: message,
        isConfirmBtn: true
      });
      return;
    }

    setHistoryList(list);
    setModalShow(true);
  };

  /* 미의뢰사유 등록 */
  const handleSubmit = () => {
    if (reason === '') {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: '미의뢰사유를 입력해주세요.',
        isConfirmBtn: true
      });
      return;
    }

    setConfirmModal({
      isOpen: true,
      title: '확인',
      message: `미의뢰 사유를 ${action}하시겠습니까?`,
      isCancelBtn: true,
      isConfirmBtn: true,
      onConfirm: () => {
        onSubmit();
      }
    });
  };
  const onSubmit = async () => {
    const requestBody = {
      unreqComment: reason,
      regUserSeq: userSeq,
      groupYn: groupYn
    };

    const response = await unrequestCreate(seq, requestBody);

    const { code, message } = response || {};

    if (code !== RESPONSE_CODE.Success) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: message,
        isConfirmBtn: true
      });
      return;
    }

    setConfirmModal({
      isOpen: true,
      title: '확인',
      message: `미의뢰내역이 ${action}되었습니다.`,
      isConfirmBtn: true
    });

    onList();
  };

  // 미의뢰정보 상세 Api 호출
  const onDetail = async () => {
    const response = await unrequestDetail(seq);

    const { code, data, message } = response || {};

    if (code !== RESPONSE_CODE.Success) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: message,
        isConfirmBtn: true
      });
      return;
    }

    const {
      ctgry1Nm,
      ctgry2Nm,
      ctgry3Nm,
      sampleNm,
      groupYn = 'Y',
      unreqCmtRegYn
    } = data || {};

    // 미의뢰내역을 등록한 경우
    if (unreqCmtRegYn === 'Y') {
      setAction('수정');
    }

    setGroupYn(groupYn);

    setUnsolicitedInfo({
      ...unsolicitedInfo,
      ctgry1Nm,
      ctgry2Nm,
      ctgry3Nm,
      sampleNm,
      unreqCmtRegYn
    });
  };

  /* 로그인 정보 */
  const loginInfo = () => {
    const { seq } = getLoginInform();
    // 로그인 user Seq
    setUserSeq(seq);
  };

  /* watch */
  useEffect(() => {
    // 로그인 정보
    loginInfo();
    // 상세API 호출
    onDetail();
  }, [seq]);

  return (
    <>
      <Card>
        <Card.Header>
          <Row className="align-items-center g-2">
            <Col>
              <h5 className="mb-0">미의뢰 사유 등록</h5>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          <h6 className="fs-0">미의뢰 정보</h6>
          <Table bordered className="fs--1 text-center">
            <tbody>
              <tr>
                <th className="bg-200 text-700" style={{ width: '10%' }}>
                  축종
                </th>
                <td>{unsolicitedInfo.ctgry1Nm || '-'}</td>
                <th className="bg-200 text-700" style={{ width: '10%' }}>
                  등록명칭
                </th>

                <td>{unsolicitedInfo.ctgry2Nm || '-'}</td>
                <th className="bg-200 text-700" style={{ width: '10%' }}>
                  등록명칭번호
                </th>
                <td>{unsolicitedInfo.ctgry3Nm || '-'}</td>
              </tr>
              <tr>
                <th className="bg-200 text-700" style={{ width: '10%' }}>
                  품목명
                </th>
                <td colSpan={5}>{unsolicitedInfo.sampleNm || '-'}</td>
              </tr>
            </tbody>
          </Table>
          <Form.Group>
            <Flex>
              <h6 className="fs-0 align-self-center">미의뢰 사유</h6>

              <Button size="sm" className="ms-auto" onClick={onHistoryModal}>
                수정 이력
              </Button>
            </Flex>
            <Flex className="cursor-pointer">
              {/* 미의뢰사유 등록 개별 or 그룹  */}
              <Form.Check
                type="radio"
                id="unuse"
                label="그룹"
                name="groupYn"
                value="Y"
                checked={groupYn === 'Y'}
                onChange={({ target: { value } }) => setGroupYn(value)}
                disabled={unsolicitedInfo.unreqCmtRegYn === 'Y'}
              />
              <Form.Check
                type="radio"
                id="use"
                label="개별"
                className="ms-3"
                name="groupYn"
                value="N"
                checked={groupYn === 'N'}
                onChange={({ target: { value } }) => setGroupYn(value)}
                disabled={unsolicitedInfo.unreqCmtRegYn === 'Y'}
              />
            </Flex>
            <Form.Control
              as="textarea"
              rows="3"
              placeholder="미의뢰 사유를 입력해주세요.(100자)"
              className="form-controll h-75"
              maxLength="100"
              value={reason}
              onChange={({ target: { value } }) => setReason(value)}
            />
          </Form.Group>
        </Card.Body>
        <Card.Footer className="d-flex align-items-center">
          <Button
            size="sm"
            variant="secondary"
            className="ms-auto"
            onClick={onList}
          >
            이전
          </Button>
          <Button size="sm" className="ms-2" onClick={handleSubmit}>
            {action}
          </Button>
        </Card.Footer>
      </Card>
      {modalShow === true && (
        <UnrequestHistory
          modalShow={modalShow}
          setModalShow={setModalShow}
          historyList={historyList}
        ></UnrequestHistory>
      )}
    </>
  );
};

export default Detail;
